const ITEMS = [
  "Sarthak ♥ Tanishka",
  "The Cocktail Evening",
  "20 · 11 · 2026",
  "Tilak Nagar · New Delhi",
  "#SARNISHKA",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-amber-500/15 py-4 bg-[#0D0E13]"
  >
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
          {ITEMS.map((t, i) => (
            <span key={i} className="flex items-center">
              <span className="font-serif-display text-lg sm:text-xl text-amber-200/80 italic whitespace-nowrap px-8">
                {t}
              </span>
              <span className="text-amber-500/60 text-xs">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
